import { useEffect, useState } from 'react';
import { IDefaultSelectOption } from '@dealroadshow/uikit-select';
import { mapToDefaultOption } from '@framework/data-helpers/selectOptionMappers';
import { ITransactionType } from '@evercall/domain/vo/TransactionType';
import { IPlatform } from '@evercall/domain/vo/Platform';

interface IProps {
  transactionTypeList: ITransactionType[],
  platformList?: IPlatform[],
}

const useCallDetailsOptions = (
  {
    transactionTypeList,
    platformList,
  }: IProps,
) => {
  const [transactionTypeOptions, setTransactionTypeOptions] = useState<Array<IDefaultSelectOption>>([]);
  const [platformOptions, setPlatformOptions] = useState<Array<IDefaultSelectOption>>([]);

  useEffect(
    () => {
      if (transactionTypeList.length && !transactionTypeOptions.length) {
        setTransactionTypeOptions(transactionTypeList.map(mapToDefaultOption));
      }
    },
    [transactionTypeList],
  );

  useEffect(
    () => {
      if (platformList?.length && !platformOptions.length) {
        setPlatformOptions(platformList.map(mapToDefaultOption));
      }
    },
    [platformList],
  );

  return {
    transactionTypeOptions,
    platformOptions,
  };
};

export default useCallDetailsOptions;
